import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import 'select2'; // globally assign select2 fn to $ element
const classes = {
	tinyfilterChannelContainer: "tintup-filter-channel",
	//buttonTest: 'js-m-html-container__button'
};

@createModule('HTMLContainer')
/**
 * HTMLContainer module implementation.
 *
 * @author Ellen Xia
 */
export class HTMLContainer extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {

		this.$ctx = $(this._ctx);

		resolve();
	}
	stop() { }
}
